export const STATUSES = [
    { key: "active", cls: "bg-blue-500/15 text-blue-300 border-blue-500/30" },
    { key: "materials", cls: "bg-amber-500/15 text-amber-300 border-amber-500/30" },
    { key: "install_wait", cls: "bg-orange-500/15 text-orange-300 border-orange-500/30" },
    { key: "installing", cls: "bg-violet-500/15 text-violet-300 border-violet-500/30" },
    { key: "done", cls: "bg-emerald-500/15 text-emerald-300 border-emerald-500/30" },
    { key: "handed", cls: "bg-teal-500/15 text-teal-300 border-teal-500/30" },
];
export const DONE = ["done", "handed"];
export const statusOf = (p) => p.info?.status || "active";
export const isDone = (p) => DONE.includes(statusOf(p));

// Status filter chips: key -> predicate.
export const FILTERS = {
    all: () => true,
    active: (p) => !isDone(p),
    done: (p) => isDone(p),
    materials: (p) => statusOf(p) === "materials",
    install_wait: (p) => statusOf(p) === "install_wait",
    installing: (p) => statusOf(p) === "installing",
    handed: (p) => statusOf(p) === "handed",
};

const norm = (s) => String(s || "").toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "").replace(/ø/g, "o").replace(/æ/g, "ae").replace(/å/g, "a");

export function searchIndex(p, folderNames) {
    const i = p.info || {};
    const parts = [i.number, p.name, i.client, i.address, i.contact, i.phone, i.email, i.pm, i.installer, ...folderNames];
    return { text: norm(parts.join(" \u0001 ")), digits: String(i.phone || "").replace(/\D/g, "") };
}

export function matches(idx, query) {
    const tokens = norm(query).split(/\s+/).filter(Boolean);
    return tokens.every((tk) => idx.text.includes(tk) || (/^\+?[\d\s-]{3,}$/.test(tk) && idx.digits.includes(tk.replace(/\D/g, ""))));
}
